

// import '../node_modules/bootstrap/dist/css/bootstrap.min.css'
import Home from "./View/Home";
import { BrowserRouter, Route } from "react-router-dom";
import Signin from "./View/Authentication/Signin";
import ProtectedRoute from "./components/ProtectedRoute";
import { connect } from 'react-redux';
import "./css/custom.css";
// import "./css/login.css";
// import "./css/theme_style.css";
import "./App.css";


function App() {
  return (
    <BrowserRouter basename="/">
    
    <Route exact path="/signin" render={props => <Signin {...props} />} />
      <ProtectedRoute path="/" component={Home} />
    </BrowserRouter>
  );
}

const mapStateToProps = state => {
  // console.log("statre", state)
  return {

    theme: state.theme,
    companyDefaults: state.companyDefaults,
  }
}

export default connect(mapStateToProps)(App);
